// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main Container */
.Tripschedule-main-wrapper {
  min-height: 100vh;

  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

/* Header */

.Tripschedule-header {
  /* background: linear-gradient(135deg, #4c1d95 0%, #7c3aed 100%); */
  background: linear-gradient(135deg, #735da5 100%, #d3c5e5 100%);
  padding: 11px 20px;
  color: white;
  text-align: center;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  margin-bottom: 40px;
}

.Tripschedule-header::before {
  content: "";
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 0.15) 0%,
    transparent 60%
  );
  animation: pulse 15s infinite linear;
}

@keyframes pulse {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.Tripschedule-header-content {
  position: relative;
  z-index: 2;
}

.Tripschedule-title {
  font-size: 28px;
  font-weight: 800;
  margin-bottom: 12px;
  letter-spacing: -0.5px;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.Tripschedule-subtitle {
  font-size: 18px;
  font-weight: 400;
  opacity: 0.9;
  text-align: center;
}

/* Top Container */
.Tripschedule-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  gap: 1rem;
  flex-wrap: wrap;
}

/* Search Container */
.Tripschedule-search-container {
  flex: 1 1;
  max-width: 400px;
}

.Tripschedule-search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.Tripschedule-search-icon {
  position: absolute;
  left: 1rem;
  width: 1.25rem;
  height: 1.25rem;
  color: #a0aec0;
  z-index: 1;
}

.Tripschedule-search-input {
  width: 100%;
  padding: 0.875rem 1rem 0.875rem 3rem;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 1rem;
  background: white;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.Tripschedule-search-input:focus {
  outline: none;
  border-color: #4299e1;
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.1);
}

/* Button Container */
.Tripschedule-button-container {
  display: flex;
  gap: 1rem;
}

.Tripschedule-schedule-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.875rem 1.5rem;
  /* background: linear-gradient(135deg, #4299e1 0%, #3182ce 100%); */
  /* background: linear-gradient(135deg, #8AAAE5 50%, #CADCFC 100%); */
  background: #6b7280;
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  /* box-shadow: 0 4px 12px rgba(66, 153, 225, 0.3); */
}

.Tripschedule-schedule-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(66, 153, 225, 0.4);
}

.Tripschedule-button-icon {
  width: 1.25rem;
  height: 1.25rem;
}

/* Modal Overlay */
.Tripschedule-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
  backdrop-filter: blur(4px);
}

/* Form Container */
.Tripschedule-form-container {
  background: white;
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
  width: 100%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
}

.Tripschedule-form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem 2rem 1rem 2rem;
  border-bottom: 1px solid #e2e8f0;
}

.Tripschedule-form-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #2d3748;
  margin: 0;
}

.Tripschedule-close-button {
  background: #f7fafc;
  border: none;
  border-radius: 8px;
  padding: 0.5rem;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #718096;
}

.Tripschedule-close-button:hover {
  background: #edf2f7;
  color: #2d3748;
}

.Tripschedule-close-button svg {
  width: 1.25rem;
  height: 1.25rem;
}

/* Form */
.Tripschedule-form {
  padding: 2rem;
}

.Tripschedule-form-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.Tripschedule-form-group {
  display: flex;
  flex-direction: column;
}

.Tripschedule-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: #4a5568;
  margin-bottom: 0.5rem;
}

.Tripschedule-select-machine,
.Tripschedule-select-driver,
.Tripschedule-select-project,
.Tripschedule-date-input {
  padding: 0.875rem 1rem;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 1rem;
  background: white;
  transition: all 0.3s ease;
}

.Tripschedule-select-machine:focus,
.Tripschedule-select-driver:focus,
.Tripschedule-select-project:focus,
.Tripschedule-date-input:focus {
  outline: none;
  border-color: #4299e1;
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.1);
}

.Tripschedule-option {
  padding: 0.5rem;
}

/* Form Actions */
.Tripschedule-form-actions {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
}

.Tripschedule-cancel-button {
  padding: 0.875rem 1.5rem;
  background: #f7fafc;
  color: #4a5568;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.Tripschedule-cancel-button:hover {
  background: #edf2f7;
  border-color: #cbd5e0;
}

.Tripschedule-submit-button {
  padding: 0.875rem 1.5rem;
  background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.Tripschedule-submit-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(72, 187, 120, 0.4);
}

/* Trips Section */
.Tripschedule-trips-section {
  margin-top: 2rem;
}

.Tripschedule-trips-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.Tripschedule-trips-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #2d3748;
  margin: 0;
}

.Tripschedule-trips-count {
  background: #4299e1;
  color: white;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 600;
}

/* Trips Grid */
.Tripschedule-trips-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 1.5rem;
}

/* Trip Card */
.Tripschedule-trip-card {
  background: white;
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  border: 1px solid #e2e8f0;
}

.Tripschedule-trip-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
}

.Tripschedule-trip-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1rem;
}

.Tripschedule-trip-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #2d3748;
  margin: 0;
  flex: 1 1;
}

.Tripschedule-trip-status {
  margin-left: 1rem;
}

/* Added trip actions container and options menu styles */
.Tripschedule-trip-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.Tripschedule-options-container {
  position: relative;
}

.Tripschedule-options-button {
  background: #6b7280;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 0.5rem;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.Tripschedule-options-button:hover {
  background: #edf2f7;
  color: #2d3748;
  border-color: #cbd5e0;
}

.Tripschedule-options-button svg {
  width: 1rem;
  height: 1rem;
}

.Tripschedule-options-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  z-index: 100;
  min-width: 120px;
  overflow: hidden;
  margin-top: 0.25rem;
}

.Tripschedule-option-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.75rem 1rem;
  border: none;
  background: white;
  color: #4a5568;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
}

.Tripschedule-option-item:hover {
  background: #f7fafc;
}

.Tripschedule-edit-option:hover {
  background: #ebf8ff;
  color: #4299e1;
}

.Tripschedule-delete-option:hover {
  background: #fed7d7;
  color: #e53e3e;
}

.Tripschedule-option-item svg {
  width: 1rem;
  height: 1rem;
}

.Tripschedule-status-badge {
  background: linear-gradient(135deg, #48bb78 0%, #38a169 100%);
  color: white;
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Trip Details */
.Tripschedule-trip-details {
  margin-bottom: 1.5rem;
}

.Tripschedule-trip-info {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.Tripschedule-info-icon {
  width: 1.125rem;
  height: 1.125rem;
  /* color: #4299e1; */
  color: #735da5;
  flex-shrink: 0;
}

.Tripschedule-trip-driver,
.Tripschedule-trip-site {
  margin: 0;
  color: #4a5568;
  font-size: 0.875rem;
}

.Tripschedule-trip-dates {
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
  padding: 12px;
  /* background: #f7fafc; */
  background: #f8f5fb;
  border-radius: 8px;
}

.Tripschedule-date-item {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.Tripschedule-date-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #718096;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.Tripschedule-trip-start-date,
.Tripschedule-trip-end-date {
  font-size: 0.875rem;
  font-weight: 600;
  color: #2d3748;
}

/* Trip Buttons */
.Tripschedule-trip-button-container {
  display: flex;
  gap: 0.75rem;
}

.Tripschedule-driver-button,
.Tripschedule-machine-button {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem 0.75rem;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  background: white;
  color: #4a5568;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.Tripschedule-driver-button:hover {
  /* border-color: #4299e1; */
  border-color: #735da5;
  /* color: #4299e1; */
  color: #735da5;
  /* background: #ebf8ff; */
  background: #e9e2f2;
}

.Tripschedule-machine-button:hover {
  /* border-color: #4299e1;
  color: #4299e1;
  background: #ebf8ff; */
  border-color: #735da5;
  color: #735da5;
  background: #e9e2f2;
}

/* Empty State */
.Tripschedule-empty-state {
  text-align: center;
  padding: 4rem 2rem;
  grid-column: 1 / -1;
}

.Tripschedule-empty-icon {
  width: 4rem;
  height: 4rem;
  color: #cbd5e0;
  margin: 0 auto 1rem auto;
}

.Tripschedule-no-trips {
  font-size: 1.25rem;
  font-weight: 600;
  color: #4a5568;
  margin: 0 0 0.5rem 0;
}

.Tripschedule-empty-subtitle {
  color: #718096;
  margin: 0;
}

/* Driver Modal */
.Tripschedule-driver-modal,
.Tripschedule-machine-modal {
  background: white;
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
}

.Tripschedule-driver-modal-content,
.Tripschedule-machine-modal-content {
  padding: 0;
}

.Tripschedule-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem 2rem 1rem 2rem;
  border-bottom: 1px solid #e2e8f0;
}

.Tripschedule-driver-modal-title,
.Tripschedule-machine-modal-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #2d3748;
  margin: 0;
}

.Tripschedule-driver-close-button,
.Tripschedule-machine-close-button {
  background: #f7fafc;
  border: none;
  border-radius: 8px;
  padding: 0.5rem;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #718096;
}

.Tripschedule-driver-close-button:hover,
.Tripschedule-machine-close-button:hover {
  background: #edf2f7;
  color: #2d3748;
}

.Tripschedule-driver-close-button svg,
.Tripschedule-machine-close-button svg {
  width: 1.25rem;
  height: 1.25rem;
}

.Tripschedule-modal-body {
  padding: 2rem;
}

/* Driver Avatar */
.Tripschedule-driver-avatar {
  display: flex;
  justify-content: center;
  margin-bottom: 2rem;
}

.Tripschedule-driver-avatar svg {
  width: 4rem;
  height: 4rem;
  color: #4299e1;
  background: #ebf8ff;
  padding: 1rem;
  border-radius: 50%;
}

/* Info Items */
.Tripschedule-driver-info,
.Tripschedule-machine-details-grid {
  display: flex;
  /* flex-direction: column; */
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: space-between;
}

.Tripschedule-machine-details-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
}

.Tripschedule-info-item {
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  /* padding: 1rem; */
  /* background: #f7fafc; */
  /* border-radius: 8px; */
  /* border-left: 4px solid #4299e1; */
  flex-direction: column;
  justify-content: space-between;
}

.Tripschedule-full-width {
  grid-column: 1 / -1;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
}

.Tripschedule-info-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: #718096;
}

.Tripschedule-driver-name,
.Tripschedule-driver-email,
.Tripschedule-machine-name,
.Tripschedule-machine-type,
.Tripschedule-machine-model,
.Tripschedule-machine-manufacturer,
.Tripschedule-machine-location,
.Tripschedule-machine-fuel-capacity,
.Tripschedule-machine-operator,
.Tripschedule-machine-purchase-date,
.Tripschedule-machine-purchase-price,
.Tripschedule-machine-serial-number,
.Tripschedule-machine-description {
  font-weight: 600;
  color: #2d3748;
}

.Tripschedule-driver-status {
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.Tripschedule-driver-status.active {
  background: #c6f6d5;
  color: #22543d;
}

.Tripschedule-driver-status.inactive {
  background: #fed7d7;
  color: #742a2a;
}

/* Responsive Design */
@media (max-width: 768px) {
  .Tripschedule-main-wrapper {
    padding: 1rem;
  }

  .Tripschedule-title {
    font-size: 2rem;
  }

  .Tripschedule-container {
    flex-direction: column;
    align-items: stretch;
  }

  .Tripschedule-search-container {
    max-width: none;
  }

  .Tripschedule-trips-grid {
    grid-template-columns: 1fr;
  }

  .Tripschedule-trip-button-container {
    flex-direction: column;
  }

  .Tripschedule-form-actions {
    flex-direction: column;
  }

  .Tripschedule-trip-dates {
    flex-direction: column;
    gap: 0.5rem;
  }

  .Tripschedule-machine-details-grid {
    grid-template-columns: 1fr;
  }

  /* Added responsive styles for options menu */
  .Tripschedule-options-menu {
    right: auto;
    left: 0;
  }
}

@media (min-width: 769px) {
  .Tripschedule-form-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .Tripschedule-machine-details-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Machine/Tripschedule.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,iBAAiB;;EAEjB,4DAA4D;AAC9D;;AAEA,WAAW;;AAEX;EACE,mEAAmE;EACnE,+DAA+D;EAC/D,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ;;;;GAIC;EACD,oCAAoC;AACtC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,eAAe;EACf,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,mEAAmE;EACnE,oEAAoE;EACpE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oDAAoD;AACtD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,SAAS;AACT;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;;EAIE,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;;;;EAIE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;AACb;;AAEA,cAAc;AACd;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,0CAA0C;EAC1C,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,SAAO;AACT;;AAEA;EACE,iBAAiB;AACnB;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,cAAc;AAChB;;AAEA;;EAEE,SAAS;EACT,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,YAAY;AACd;;AAEA;;EAEE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,oBAAoB;EACpB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE;;wBAEsB;EACtB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA,iBAAiB;AACjB;;EAEE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA,eAAe;AACf;;EAEE,aAAa;EACb,4BAA4B;EAC5B,SAAS;EACT,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;EACxB,oCAAoC;EACpC,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;;;;;;;;;;;EAaE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA,6CAA6C;EAC7C;IACE,WAAW;IACX,OAAO;EACT;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;AACF","sourcesContent":["/* Main Container */\n.Tripschedule-main-wrapper {\n  min-height: 100vh;\n\n  font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\n}\n\n/* Header */\n\n.Tripschedule-header {\n  /* background: linear-gradient(135deg, #4c1d95 0%, #7c3aed 100%); */\n  background: linear-gradient(135deg, #735da5 100%, #d3c5e5 100%);\n  padding: 11px 20px;\n  color: white;\n  text-align: center;\n  position: relative;\n  overflow: hidden;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  margin-bottom: 40px;\n}\n\n.Tripschedule-header::before {\n  content: \"\";\n  position: absolute;\n  top: -50%;\n  left: -50%;\n  width: 200%;\n  height: 200%;\n  background: radial-gradient(\n    circle,\n    rgba(255, 255, 255, 0.15) 0%,\n    transparent 60%\n  );\n  animation: pulse 15s infinite linear;\n}\n\n@keyframes pulse {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.Tripschedule-header-content {\n  position: relative;\n  z-index: 2;\n}\n\n.Tripschedule-title {\n  font-size: 28px;\n  font-weight: 800;\n  margin-bottom: 12px;\n  letter-spacing: -0.5px;\n  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.Tripschedule-subtitle {\n  font-size: 18px;\n  font-weight: 400;\n  opacity: 0.9;\n  text-align: center;\n}\n\n/* Top Container */\n.Tripschedule-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n/* Search Container */\n.Tripschedule-search-container {\n  flex: 1;\n  max-width: 400px;\n}\n\n.Tripschedule-search-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.Tripschedule-search-icon {\n  position: absolute;\n  left: 1rem;\n  width: 1.25rem;\n  height: 1.25rem;\n  color: #a0aec0;\n  z-index: 1;\n}\n\n.Tripschedule-search-input {\n  width: 100%;\n  padding: 0.875rem 1rem 0.875rem 3rem;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  font-size: 1rem;\n  background: white;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.Tripschedule-search-input:focus {\n  outline: none;\n  border-color: #4299e1;\n  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.1);\n}\n\n/* Button Container */\n.Tripschedule-button-container {\n  display: flex;\n  gap: 1rem;\n}\n\n.Tripschedule-schedule-button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.875rem 1.5rem;\n  /* background: linear-gradient(135deg, #4299e1 0%, #3182ce 100%); */\n  /* background: linear-gradient(135deg, #8AAAE5 50%, #CADCFC 100%); */\n  background: #6b7280;\n  color: white;\n  border: none;\n  border-radius: 12px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  /* box-shadow: 0 4px 12px rgba(66, 153, 225, 0.3); */\n}\n\n.Tripschedule-schedule-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(66, 153, 225, 0.4);\n}\n\n.Tripschedule-button-icon {\n  width: 1.25rem;\n  height: 1.25rem;\n}\n\n/* Modal Overlay */\n.Tripschedule-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 1rem;\n  backdrop-filter: blur(4px);\n}\n\n/* Form Container */\n.Tripschedule-form-container {\n  background: white;\n  border-radius: 20px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);\n  width: 100%;\n  max-width: 600px;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.Tripschedule-form-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 2rem 2rem 1rem 2rem;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.Tripschedule-form-title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #2d3748;\n  margin: 0;\n}\n\n.Tripschedule-close-button {\n  background: #f7fafc;\n  border: none;\n  border-radius: 8px;\n  padding: 0.5rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  color: #718096;\n}\n\n.Tripschedule-close-button:hover {\n  background: #edf2f7;\n  color: #2d3748;\n}\n\n.Tripschedule-close-button svg {\n  width: 1.25rem;\n  height: 1.25rem;\n}\n\n/* Form */\n.Tripschedule-form {\n  padding: 2rem;\n}\n\n.Tripschedule-form-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.Tripschedule-form-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.Tripschedule-label {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #4a5568;\n  margin-bottom: 0.5rem;\n}\n\n.Tripschedule-select-machine,\n.Tripschedule-select-driver,\n.Tripschedule-select-project,\n.Tripschedule-date-input {\n  padding: 0.875rem 1rem;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 1rem;\n  background: white;\n  transition: all 0.3s ease;\n}\n\n.Tripschedule-select-machine:focus,\n.Tripschedule-select-driver:focus,\n.Tripschedule-select-project:focus,\n.Tripschedule-date-input:focus {\n  outline: none;\n  border-color: #4299e1;\n  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.1);\n}\n\n.Tripschedule-option {\n  padding: 0.5rem;\n}\n\n/* Form Actions */\n.Tripschedule-form-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: flex-end;\n}\n\n.Tripschedule-cancel-button {\n  padding: 0.875rem 1.5rem;\n  background: #f7fafc;\n  color: #4a5568;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.Tripschedule-cancel-button:hover {\n  background: #edf2f7;\n  border-color: #cbd5e0;\n}\n\n.Tripschedule-submit-button {\n  padding: 0.875rem 1.5rem;\n  background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.Tripschedule-submit-button:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 20px rgba(72, 187, 120, 0.4);\n}\n\n/* Trips Section */\n.Tripschedule-trips-section {\n  margin-top: 2rem;\n}\n\n.Tripschedule-trips-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n}\n\n.Tripschedule-trips-title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #2d3748;\n  margin: 0;\n}\n\n.Tripschedule-trips-count {\n  background: #4299e1;\n  color: white;\n  padding: 0.25rem 0.75rem;\n  border-radius: 20px;\n  font-size: 0.875rem;\n  font-weight: 600;\n}\n\n/* Trips Grid */\n.Tripschedule-trips-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\n  gap: 1.5rem;\n}\n\n/* Trip Card */\n.Tripschedule-trip-card {\n  background: white;\n  border-radius: 16px;\n  padding: 1.5rem;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  transition: all 0.3s ease;\n  border: 1px solid #e2e8f0;\n}\n\n.Tripschedule-trip-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);\n}\n\n.Tripschedule-trip-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 1rem;\n}\n\n.Tripschedule-trip-title {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #2d3748;\n  margin: 0;\n  flex: 1;\n}\n\n.Tripschedule-trip-status {\n  margin-left: 1rem;\n}\n\n/* Added trip actions container and options menu styles */\n.Tripschedule-trip-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.Tripschedule-options-container {\n  position: relative;\n}\n\n.Tripschedule-options-button {\n  background: #6b7280;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  padding: 0.5rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  color: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.Tripschedule-options-button:hover {\n  background: #edf2f7;\n  color: #2d3748;\n  border-color: #cbd5e0;\n}\n\n.Tripschedule-options-button svg {\n  width: 1rem;\n  height: 1rem;\n}\n\n.Tripschedule-options-menu {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  z-index: 100;\n  min-width: 120px;\n  overflow: hidden;\n  margin-top: 0.25rem;\n}\n\n.Tripschedule-option-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  width: 100%;\n  padding: 0.75rem 1rem;\n  border: none;\n  background: white;\n  color: #4a5568;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: left;\n}\n\n.Tripschedule-option-item:hover {\n  background: #f7fafc;\n}\n\n.Tripschedule-edit-option:hover {\n  background: #ebf8ff;\n  color: #4299e1;\n}\n\n.Tripschedule-delete-option:hover {\n  background: #fed7d7;\n  color: #e53e3e;\n}\n\n.Tripschedule-option-item svg {\n  width: 1rem;\n  height: 1rem;\n}\n\n.Tripschedule-status-badge {\n  background: linear-gradient(135deg, #48bb78 0%, #38a169 100%);\n  color: white;\n  padding: 0.25rem 0.75rem;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n/* Trip Details */\n.Tripschedule-trip-details {\n  margin-bottom: 1.5rem;\n}\n\n.Tripschedule-trip-info {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 0.75rem;\n}\n\n.Tripschedule-info-icon {\n  width: 1.125rem;\n  height: 1.125rem;\n  /* color: #4299e1; */\n  color: #735da5;\n  flex-shrink: 0;\n}\n\n.Tripschedule-trip-driver,\n.Tripschedule-trip-site {\n  margin: 0;\n  color: #4a5568;\n  font-size: 0.875rem;\n}\n\n.Tripschedule-trip-dates {\n  display: flex;\n  gap: 1rem;\n  margin-top: 1rem;\n  padding: 12px;\n  /* background: #f7fafc; */\n  background: #f8f5fb;\n  border-radius: 8px;\n}\n\n.Tripschedule-date-item {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.Tripschedule-date-label {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #718096;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.Tripschedule-trip-start-date,\n.Tripschedule-trip-end-date {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #2d3748;\n}\n\n/* Trip Buttons */\n.Tripschedule-trip-button-container {\n  display: flex;\n  gap: 0.75rem;\n}\n\n.Tripschedule-driver-button,\n.Tripschedule-machine-button {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 0.75rem 0.75rem;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  background: white;\n  color: #4a5568;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.Tripschedule-driver-button:hover {\n  /* border-color: #4299e1; */\n  border-color: #735da5;\n  /* color: #4299e1; */\n  color: #735da5;\n  /* background: #ebf8ff; */\n  background: #e9e2f2;\n}\n\n.Tripschedule-machine-button:hover {\n  /* border-color: #4299e1;\n  color: #4299e1;\n  background: #ebf8ff; */\n  border-color: #735da5;\n  color: #735da5;\n  background: #e9e2f2;\n}\n\n/* Empty State */\n.Tripschedule-empty-state {\n  text-align: center;\n  padding: 4rem 2rem;\n  grid-column: 1 / -1;\n}\n\n.Tripschedule-empty-icon {\n  width: 4rem;\n  height: 4rem;\n  color: #cbd5e0;\n  margin: 0 auto 1rem auto;\n}\n\n.Tripschedule-no-trips {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #4a5568;\n  margin: 0 0 0.5rem 0;\n}\n\n.Tripschedule-empty-subtitle {\n  color: #718096;\n  margin: 0;\n}\n\n/* Driver Modal */\n.Tripschedule-driver-modal,\n.Tripschedule-machine-modal {\n  background: white;\n  border-radius: 20px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);\n  width: 100%;\n  max-width: 500px;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.Tripschedule-driver-modal-content,\n.Tripschedule-machine-modal-content {\n  padding: 0;\n}\n\n.Tripschedule-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 2rem 2rem 1rem 2rem;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.Tripschedule-driver-modal-title,\n.Tripschedule-machine-modal-title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #2d3748;\n  margin: 0;\n}\n\n.Tripschedule-driver-close-button,\n.Tripschedule-machine-close-button {\n  background: #f7fafc;\n  border: none;\n  border-radius: 8px;\n  padding: 0.5rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  color: #718096;\n}\n\n.Tripschedule-driver-close-button:hover,\n.Tripschedule-machine-close-button:hover {\n  background: #edf2f7;\n  color: #2d3748;\n}\n\n.Tripschedule-driver-close-button svg,\n.Tripschedule-machine-close-button svg {\n  width: 1.25rem;\n  height: 1.25rem;\n}\n\n.Tripschedule-modal-body {\n  padding: 2rem;\n}\n\n/* Driver Avatar */\n.Tripschedule-driver-avatar {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 2rem;\n}\n\n.Tripschedule-driver-avatar svg {\n  width: 4rem;\n  height: 4rem;\n  color: #4299e1;\n  background: #ebf8ff;\n  padding: 1rem;\n  border-radius: 50%;\n}\n\n/* Info Items */\n.Tripschedule-driver-info,\n.Tripschedule-machine-details-grid {\n  display: flex;\n  /* flex-direction: column; */\n  gap: 1rem;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n\n.Tripschedule-machine-details-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 1rem;\n}\n\n.Tripschedule-info-item {\n  display: flex;\n  /* justify-content: space-between; */\n  align-items: center;\n  /* padding: 1rem; */\n  /* background: #f7fafc; */\n  /* border-radius: 8px; */\n  /* border-left: 4px solid #4299e1; */\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.Tripschedule-full-width {\n  grid-column: 1 / -1;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.5rem;\n}\n\n.Tripschedule-info-label {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #718096;\n}\n\n.Tripschedule-driver-name,\n.Tripschedule-driver-email,\n.Tripschedule-machine-name,\n.Tripschedule-machine-type,\n.Tripschedule-machine-model,\n.Tripschedule-machine-manufacturer,\n.Tripschedule-machine-location,\n.Tripschedule-machine-fuel-capacity,\n.Tripschedule-machine-operator,\n.Tripschedule-machine-purchase-date,\n.Tripschedule-machine-purchase-price,\n.Tripschedule-machine-serial-number,\n.Tripschedule-machine-description {\n  font-weight: 600;\n  color: #2d3748;\n}\n\n.Tripschedule-driver-status {\n  padding: 0.25rem 0.75rem;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.Tripschedule-driver-status.active {\n  background: #c6f6d5;\n  color: #22543d;\n}\n\n.Tripschedule-driver-status.inactive {\n  background: #fed7d7;\n  color: #742a2a;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .Tripschedule-main-wrapper {\n    padding: 1rem;\n  }\n\n  .Tripschedule-title {\n    font-size: 2rem;\n  }\n\n  .Tripschedule-container {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .Tripschedule-search-container {\n    max-width: none;\n  }\n\n  .Tripschedule-trips-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .Tripschedule-trip-button-container {\n    flex-direction: column;\n  }\n\n  .Tripschedule-form-actions {\n    flex-direction: column;\n  }\n\n  .Tripschedule-trip-dates {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n\n  .Tripschedule-machine-details-grid {\n    grid-template-columns: 1fr;\n  }\n\n  /* Added responsive styles for options menu */\n  .Tripschedule-options-menu {\n    right: auto;\n    left: 0;\n  }\n}\n\n@media (min-width: 769px) {\n  .Tripschedule-form-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .Tripschedule-machine-details-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
